import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import { httpAction, getAction } from '@/api/manage';
import pick from 'lodash.pick';
import moment from 'moment';
import SelectSiteListModal from "../../SelectSiteListModal";
import SelectProductModal from "../../SelectProductModal";
import IwsUpload from '@comp/upload/IwsUpload';
var columns = [{
  title: '序号',
  dataIndex: '',
  key: 'rowIndex',
  width: '8%',
  align: 'center',
  customRender: function customRender(t, r, index) {
    return parseInt(index) + 1;
  }
}, {
  title: '出厂编号',
  dataIndex: 'sn',
  align: 'center',
  width: '18%',
  scopedSlots: {
    customRender: 'sn'
  }
}, {
  title: '生产日期',
  dataIndex: 'productionDate',
  align: 'center',
  width: '15%',
  scopedSlots: {
    customRender: 'productionDate'
  }
}, {
  title: '证书编号',
  dataIndex: 'certificateNo',
  align: 'center',
  width: '18%',
  scopedSlots: {
    customRender: 'certificateNo'
  }
}, {
  title: '原值（元）',
  dataIndex: 'worth',
  align: 'center',
  width: '15%',
  scopedSlots: {
    customRender: 'worth'
  }
}, {
  title: '操作',
  align: 'center',
  dataIndex: 'operation',
  scopedSlots: {
    customRender: 'operation'
  }
}];
var addIndex = 1;
var dataSource = [{
  key: 'A1_0',
  sn: '',
  productionDate: '',
  certificateNo: '',
  worth: '',
  copyNum: 1,
  editable: true
}];
export default {
  name: 'ProductInfoModal',
  components: {
    SelectSiteListModal: SelectSiteListModal,
    SelectProductModal: SelectProductModal,
    IwsUpload: IwsUpload
  },
  mixins: [ModalFormMixin],
  data: function data() {
    this.cacheData = dataSource.map(function (item) {
      return _objectSpread({}, item);
    });
    return {
      title: '资产清单表单',
      tableName: 'ea_asset_info',
      form_fields: ['supplierId', 'volume', 'sn', 'status', 'batchNo'],
      form_fields_time: ['purchaseDate'],
      chemical_fields: ['certificateNo'],
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 10
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 14
        }
      },
      labelCol1: {
        xs: {
          span: 24
        },
        sm: {
          span: 3
        }
      },
      wrapperCol1: {
        xs: {
          span: 24
        },
        sm: {
          span: 15
        }
      },
      validatorRules: {
        productId: {
          rules: [{
            required: true,
            message: '请选择产品!'
          }]
        },
        volume: {
          rules: [{
            required: true,
            message: '请输入单位体积!'
          }]
        },
        supplierId: {
          rules: [{
            required: true,
            message: '请选择供应商!'
          }]
        },
        status: {
          rules: [{
            required: true,
            message: '请选择资产状态!'
          }]
        },
        purchaseDate: {
          rules: [{
            required: true,
            message: '请选择购置日期!'
          }]
        },
        voucher: {
          rules: [{
            required: true,
            message: '请输入凭证编号!'
          }]
        }
      },
      columns: columns,
      addIndex: addIndex,
      dataSource: dataSource,
      url: {
        carInfo: '/ea/asset/car',
        chemicalInfo: '/ea/asset/chemical/addBatch',
        equipmentInfo: '/ea/asset/equipment',
        queryCompany: '/ea/company/info/queryCompanyName',
        assetInfo: '/ea/asset/info/addBatch'
      },
      headers: {},
      uploadLoading: false,
      category: '',
      companyList: [],
      factorOptions: [],
      selectedProduct: [],
      productIds: []
    };
  },
  props: ['pagePath', 'danger'],
  created: function created() {},
  methods: {
    add: function add() {
      this.edit({});
    },
    edit: function edit(record) {
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.loadCompany(); //厂商

      this.selectedProduct = [];
      this.productIds = [];
      this.model.category = this.category;
      this.visible = true;
      this.dataSource = [{
        key: 'A1_0',
        sn: '',
        productionDate: '',
        certificateNo: '',
        worth: '',
        copyNum: 1,
        editable: true
      }];
    },
    loadCompany: function loadCompany() {
      var that = this;
      that.companyList = [];
      getAction(this.url.queryCompany).then(function (res) {
        if (res.success) {
          that.companyList = res.result;
        }
      });
    },
    loadProduct: function loadProduct() {
      var _this = this;

      getAction(this.infourl + '/' + this.model.id).then(function (res) {
        if (res.success) {
          _this.model = Object.assign({}, res.result);
          _this.model.category = _this.category;

          _this.renderProductModel();
        }
      });
    },
    handleCopy: function handleCopy(value, key) {
      var newData = _toConsumableArray(this.dataSource);

      var target = newData.filter(function (item) {
        return key === item.key;
      })[0];

      if (target) {
        target.copyNum = value;
        this.dataSource = newData;
      }
    },
    // 表格相关的操作函数
    handleChangeTable: function handleChangeTable(value, key, column) {
      var newData = _toConsumableArray(this.dataSource);

      var target = newData.filter(function (item) {
        return key === item.key;
      })[0];

      if (target) {
        target[column] = value;
        this.dataSource = newData;
      }
    },
    copyTable: function copyTable(key) {
      var newData = _toConsumableArray(this.dataSource);

      var target = newData.filter(function (item) {
        return key === item.key;
      })[0];

      if (target) {
        var copyNum = target.copyNum ? target.copyNum : 1;

        for (var i = 0; i < copyNum; i++) {
          newData.push({
            key: 'A1_' + this.addIndex + i,
            sn: target.sn,
            productionDate: target.productionDate,
            certificateNo: target.certificateNo,
            worth: target.worth,
            editable: true
          });
        }

        this.addIndex = this.addIndex + copyNum;
      }

      this.dataSource = newData;
      this.cacheData = newData.map(function (item) {
        return _objectSpread({}, item);
      });
    },
    delTable: function delTable(key) {
      var newData = this.dataSource.filter(function (item) {
        return key != item.key;
      });
      this.dataSource = newData;
      this.cacheData = newData.map(function (item) {
        return _objectSpread({}, item);
      });
    },
    handleOk: function handleOk() {
      var _this2 = this;

      var that = this;
      console.log(this.dataSource); // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(that.model, values); //时间格式化

          that.form_fields_time.forEach(function (item, index) {
            formData[item] = formData[item] ? formData[item].format(that.$refs[item]['format']) : null;
          });
          var httpurl = _this2.url.chemicalInfo,
              method = '';

          if (!_this2.model.id) {
            method = 'post';
          } else {
            method = 'put';
          }

          formData.productId = that.productIds && (that.productIds == [] || that.productIds.length == 0) ? '' : that.productIds;
          console.log(_this2.dataSource);

          _this2.dataSource.forEach(function (e) {
            e = Object.assign(e, formData);
          });

          httpAction(httpurl, _this2.dataSource, method).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    selectProducts: function selectProducts() {
      console.log(this.danger);
      this.$refs.ProductListModal.danger = this.danger;
      this.$refs.ProductListModal.category = this.category;
      this.$refs.ProductListModal.disableSubmit = true;
      this.$refs.ProductListModal.add(this.selectedProduct, this.productIds);
    },
    // 子modal回调
    choseProduct: function choseProduct(productList) {
      this.selectedProduct = [];
      this.productIds = [];

      for (var i = 0; i < productList.length; i++) {
        this.selectedProduct.push(productList[i].name);
        this.productIds = productList[i].id;
      }
    }
  }
};